import { render, staticRenderFns } from "./CompanyEditModules.vue?vue&type=template&id=0604fd3c&"
import script from "./CompanyEditModules.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0604fd3c')) {
      api.createRecord('0604fd3c', component.options)
    } else {
      api.reload('0604fd3c', component.options)
    }
    module.hot.accept("./CompanyEditModules.vue?vue&type=template&id=0604fd3c&", function () {
      api.rerender('0604fd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModules.vue"
export default component.exports